import { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { DialogOverlay, DialogContent } from '@reach/dialog'
import { Heading } from '../typography/Heading'
import { RichText } from '../rich-text'
import { Button } from '../button'
import '@reach/dialog/styles.css'
import * as styles from './ApplyModal.module.scss'
import CloseImage from '../../images-global/close.svg'

const ApplyModal = ({
  open,
  onDismiss,
  cta1text,
  cta1Alt,
  cta1href,
  cta2text,
  cta2Alt,
  cta2href,
}) => {
  const [t] = useTranslation()
  const imgSrcSets = [
    {
      height: 220,
    },
  ]

  return (
    <DialogOverlay className={styles.DialogOverlay} isOpen={open} onDismiss={onDismiss}>
      <DialogContent
        className={styles.DialogContent}
        aria-label={t('ApplyModal.ariaLabel', {
          defaultValue: `Are you an existing member?`,
        })}
        data-qa="apply-modal"
      >
        <Fragment>
          <div className={styles.topContainer}>
            <svg
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 138 85"
              className={styles.LogoMark}
              aria-hidden="true"
              focusable="false"
            >
              <g fill="none" fillRule="nonzero">
                <path
                  fill="#63B5E5"
                  d="M129.3 11.7c-22.5 17.4-48.4 59.4-52.7 70.5-.4 1 .4 1.9 1.4 2.2a13.3 13.3 0 0 0 3 .6 2.7 2.7 0 0 0 2.6-1.6c10-21.7 29.2-56 46.6-71.1.8-.6.2-1.5-.9-.6"
                />
                <path
                  fill="#84BD41"
                  d="M57.183 31.656a.401.401 0 0 1-.402-.402l.2-9.138c0-.2.202-.301.402-.301s29.093 4.72 36.918 5.623h.401A187.603 187.603 0 0 1 123.996 6.35c3.879-2.265 7.9-4.278 12.038-6.025.703-.3 1.505-.502 1.806-.1.301.402.2 1.004-.502 1.406C104.734 20.509 81.36 56.86 68.92 82.166c-.204.44-.622.744-1.104.803a4.51 4.51 0 0 1-1.605-.1C46.85 79.756.702 71.12.702 71.12a.401.401 0 0 1-.401-.402L0 57.564c0-.302.2-.503.401-.402l61.095 10.142.502-.2 4.213-6.729a24.604 24.604 0 0 0 1.605-2.41l.301-.401c.201-.302 0-.603-.4-.703L28.09 49.43c-.201 0-.301-.201-.301-.402l-.301-11.448c0-.2.2-.401.401-.3l48.756 8.434c.1.1.401-.1.501-.1 1.806-2.21 3.712-4.419 5.217-6.025l1.906-2.109c.401-.502.301-.904-.2-1.004l-26.886-4.82"
                />
              </g>
            </svg>
            <Heading element="h1" size={3} className={styles.heading}>
              {t('applyModal.heading', {
                defaultValue: "Let's get started!",
              })}
              <br />
              {t('applyModal.heading2', {
                defaultValue: "We've made it easy for you...",
              })}
            </Heading>
            {/* <p>
              {t('applyModal.mainText', {
                defaultValue:
                  'Thank you for your interest in applying. Are you a member of Elevations Credit Union? If not, no problem. We’ll get you membership, as well.',
              })}
            </p> */}
          </div>

          <div className={styles.ApplyModalBody}>
            {cta1text && cta1href && (
              <div className={styles.buttonContainer} data-qa="apply-modal-bottom-container">
                <div className={styles.leftContainer}>
                  <Heading element="h3" size={4}>
                    {t('applyModal.isMember', {
                      defaultValue: 'Are you a member?',
                    })}
                  </Heading>
                  <p>
                    {t('applyModal.memberText', {
                      defaultValue: 'Log into digital banking to start your application.',
                    })}
                  </p>
                  <Button
                    className={styles.CtaButton}
                    url={cta1href}
                    data-qa="apply-modal-upper-button"
                    alt={cta1Alt}
                  >
                    {t('applyModal.buttonOne', {
                      defaultValue: `Yes`,
                    })}
                  </Button>
                </div>
                {cta2href && cta2text && (
                  <div className={styles.rightContainer}>
                    <Heading element="h3" size={4}>
                      {t('applyModal.becomeMember', {
                        defaultValue: 'Become a member',
                      })}
                    </Heading>
                    <p>
                      {t('applyModal.nonMemberText', {
                        defaultValue:
                          'It all starts with your membership. Why not become a member today and start enjoying the benefits?',
                      })}
                    </p>
                    <a href="https://www.elevationscu.com/resources/become-a-member" className={styles.learnMore}>
                      Learn more about membership
                    </a>
                    <Button
                      variant="secondary"
                      url={cta2href}
                      className={styles.Cta2Button}
                      alt={cta2Alt}
                      data-qa="apply-modal-lower-button"
                    >
                      {t('applyModal.buttonTwo', {
                        defaultValue: `No`,
                      })}
                    </Button>
                  </div>
                )}
              </div>
            )}
          </div>
        </Fragment>
      </DialogContent>
    </DialogOverlay>
  )
}

ApplyModal.propTypes = {
  onDismiss: PropTypes.func,
  open: PropTypes.bool,
  cta1href: PropTypes.string,
  cta1text: PropTypes.string,
  cta1Alt: PropTypes.string,
  cta2href: PropTypes.string,
  cta2text: PropTypes.string,
  cta2Alt: PropTypes.string,
}

export { ApplyModal }
export default ApplyModal
